export default __webpack_public_path__ + "static/2-33746d546db1c0b17de931e865d6256b.jpg";